<template>
  <div class="body-box marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addBanner">新增</el-button>
      </el-col>
      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery" />
      </el-col>
    </el-row>

    <!--banner列表-->
    <el-table :height="'calc(100% - 70px)'" :data="bannerList" class="button-box">
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="图片MD5值" prop="md5">
        <template slot-scope="scope">
          <icon-img :icon="scope.row.md5"></icon-img>
        </template>
      </el-table-column>
      <el-table-column label="类型" prop="enumType">
        <template slot-scope="scope">
          {{scope.row.enumType === 'INDEX' ? '首页轮播' : '比赛轮播'}}
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort"></el-table-column>
      <el-table-column label="是否启用" prop="enumEnable">
        <template slot-scope="scope">
          {{scope.row.enumEnable === 'NORMAL' ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180px">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="edtiBanner(scope.row)">修改</el-button>
          <el-button icon="el-icon-delete" @click="removeBannerById(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref="page" :query-param.sync="queryInfo" @pagination="getBannerList" /></div>


    <addBanner @refresh-list="handleQuery" ref="addBanner"></addBanner>
    <editBanner @refresh-list="handleQuery" ref="editBanner"></editBanner>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination/index'
import addBanner from '@/views/banner/addBanner'
import editBanner from '@/views/banner/editBanner'
import { getPostOrDeleteData } from '@/utils/code'
import { deleteBanner, getBannerList } from '@/api/banner/banner'
import SearchInput from '@/components/common/searchInput/searchInput'
import IconImg from '@/components/common/pictureImg/index'


export default {
  components: { IconImg, SearchInput, Pagination, addBanner, editBanner },
  data() {
    return {
      queryInfo: {
        keyword: ''
      },
      bannerList: []
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    //查询列表
    getBannerList(page, cb) {
      getBannerList(page).then((response) => {
        this.bannerList = cb(response)
      })
    },

    //根据ID删除数据
    removeBannerById(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBanner(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }).catch(() => {
      })
    },

    //新增
    addBanner() {
      this.$refs.addBanner.addDialog()
    },

    // 修改
    edtiBanner(row) {
      this.$refs.editBanner.editDialog(row)
    },

    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
